import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setPickupAddressState } from '../store/pickupAddress.actions'

export function* getPickupAddress(pcrDoc: IPcr) {
  const pickupAddress = pcrDoc.patient?.pickupAddress
  if (pickupAddress && Object.keys(pickupAddress).length !== 0) {
    yield put(setPickupAddressState(pickupAddress))
  }
}
